/* src/app/user-default/documents/documents.component.scss */
/*# sourceMappingURL=documents.component-2GBSUVYJ.css.map */
